import { IRepresentationWidget } from "../@types/chart.type";

export const listRepresentationWidgetsMock: IRepresentationWidget[] = [
  {
    widgetId: "61891114-58c5-4738-99e1-5fee3a24ad8e",
    widgetName: "Capacity da Empresa",
    type: "line",
    size: "two",
    description:
      "Indicadores referente ao total de horas alocadas e não alocadas da Empresa.",
  },
  {
    widgetId: "88f9da8b-8afc-400f-8434-5bcaa87f0949",
    widgetName: "Projetos acima do custo",
    type: "barVertical",
    size: "two",
    description: "Gráfico contendo os projetos que ultrapassaram o orçamento.",
  },
  {
    widgetId: "d9b2f5b8-6669-4b88-b5a8-f4e71ee2f25c",
    widgetName: "Visão financeira dos projetos",
    type: "barVertical",
    size: "two",
    description: "Gráfico com a visão financeira dos projetos.",
  },
  {
    widgetId: "e51ca84c-238d-4d5f-ac70-d5aae155be0c",
    widgetName: "Meus Colaboradores indisponíveis",
    type: "grid",
    size: "two",
    description:
      "Listagem dos colaboradores que atualmente estão indisponíveis.",
  },
  {
    widgetId: "d77c6007-8f75-4162-9e77-55513022083a",
    widgetName: "Colaboradores Indisponíveis da Empresa",
    type: "grid",
    size: "two",
    description:
      "Listagem dos colaboradores que atualmente estão indisponíveis na empresa em geral.",
  },
  {
    widgetId: "2630a5d3-fce9-49d4-92c0-b11ed3a4a6a0",
    widgetName: "Projetos sem orçamento",
    type: "grid",
    size: "two",
    description: "Gráfico que informa os projetos sem orçamento.",
  },
  {
    widgetId: "3f5e1a7c-9b2d-4e4a-8f3c-72d6a1e5b4c9",
    widgetName: "Projetos sem alocações no mês atual",
    type: "grid",
    size: "two",
    description:
      "Gráfico que informa as informações dos projetos que não possuem alocação no mês atual.",
  },
  {
    widgetId: "8cc546ea-d193-44a2-a7d9-1706660853b1",
    widgetName: "Colaboradores em ociosidade",
    type: "grid",
    size: "two",
    description: "Listagem dos colaboradores e suas horas ociosas no mês.",
  },
  {
    widgetId: "98416a47-d0e8-42dd-b982-cb57a7776b55",
    widgetName: "Colaboradores da empresa que possuem ociosidade",
    type: "grid",
    size: "two",
    description:
      "Gráfico que informa a quantidade de horas ociosas de cada colaborador que possua ociosidade.",
  },
  {
    widgetId: "7a910f0f-360e-473a-ba2a-f2833fe3797c",
    widgetName: "Custo por ociosidade dos colaboradores",
    type: "grid",
    size: "two",
    description:
      "Lista os custos dos seus colaboradores com ociosidade no mês atual.",
  },
  {
    widgetId: "09fe2a2b-0503-47e0-9313-b0784d1f34cd",
    widgetName: "Capacity da Empresa + Ociosidade",
    type: "donnut",
    size: "two",
    description:
      "Gráfico contendo o total de horas faturadas / não faturadas + ociosidade da Empresa.",
  },
  {
    widgetId: "7179f77b-515c-45bc-81a9-8f6a3a04d20f",
    widgetName: "Capacity dos meus colaboradores",
    type: "donnut",
    size: "two",
    description:
      "Gráfico contendo o total de horas faturadas / não faturadas + ociosidade dos meus colaboradores.",
  },
  {
    widgetId: "29cf0eda-7a52-4105-afca-c2d1775186cf",
    widgetName: "Custo por Ociosidade",
    type: "barVertical",
    size: "two",
    description:
      "Gráfico que mostra uma visão mensal do custo por ociosidade da Empresa.",
  },
  {
    widgetId: "efe64466-2c1c-4b27-ab15-3fbdaa88a07b",
    widgetName: "Capacity por função",
    type: "barHorizontal",
    size: "two",
    description: "Gráfico que informa o capacity separado por função.",
  },
];
